import React, { useMemo } from "react";
import { format } from "date-fns";
import { useSelector } from "react-redux";

// Material
import { makeStyles } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";

// Hooks
import useTranslate from "../../hooks/useTranslate";

// Components
import Text from "../Text";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  heading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(2.5),
    width: "100%"
  },
  avatar: {
    height: 36,
    width: 36,
    marginRight: theme.spacing(1)
  },
  headingInfo: {
    display: "flex",
    flexDirection: "column"
  }
}));

const StatementAuthor = ({ answeredDateTime, authorId }) => {
  const getText = useTranslate();
  const classes = useStyles();

  const { contributors, isLoadingContributors } = useSelector(
    s => s.caseDetail
  );
  const { userDetails, isLoading } = useSelector(s => s.user);

  const date = useMemo(
    () =>
      format(
        new Date(answeredDateTime),
        getText("common.dateFormat.timeOnDate")
      ),
    [answeredDateTime, getText]
  );

  const user = useMemo(() => {
    if (isLoadingContributors) return null;

    const found = contributors?.find(c => String(c.id) === String(authorId));

    if (found) {
      return {
        fullName: found.fullName,
        profilePhotoURL: found.profilePictureURL
      };
    }

    return userDetails ?? null;
  }, [contributors, isLoadingContributors, authorId, userDetails]);

  return isLoadingContributors || isLoading || !user ? (
    <div className={classes.heading}>
      <Skeleton variant="circle" width={36} height={36} />
    </div>
  ) : (
    <div className={classes.heading}>
      <Avatar className={classes.avatar} src={user.profilePhotoURL} />
      <div className={classes.headingInfo}>
        <Text type="heading6">{user.fullName}</Text>
        <Text type="contentLabel">{date}</Text>
      </div>
    </div>
  );
};

StatementAuthor.propTypes = {};

export default StatementAuthor;
